import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import {
    DTypeCol, DTypeViewableCol
} from '@grupo-constant/next-dtype/types';
import { Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype/dtype-field.model';
import { DTypeService } from '../../dtype/dtype.service';

@Component({
    selector: 'field-chiplist-component',
    templateUrl: './field-chiplist.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldChiplistComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {


    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;
    @Input() validTypes: string[] = [];

    // TEXT MASK
    columns: DTypeCol[];
    isNameIndex: boolean;
    fields: string[] = [];

    private _unsubscribeAll = new Subject<void>();

    constructor(private dtypeService: DTypeService) { }

    ngOnInit() {
        this.fields = this.field.control.value ?? [];
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        this.dtypeService.tableComponentColumns$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((columns) => {
                this.columns = this.isNameIndex ? columns : columns.filter(c => this.columnIsValid(c));
            });
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    add(column: DTypeCol) {
        this.fields.push(column.name);
        this.field.control.setValue(this.fields);
    }

    chipAlreadyExist(name: string) {
        return this.fields?.some(i => i === name);
    }

    removeChip(name: string) {
        const index = this.fields.findIndex(ui => ui === name);
        if (index > -1) {
            this.fields.splice(index, 1);
            this.field.control.setValue(this.fields);
        }
    }

    private columnIsValid(column: DTypeCol) {
        return this.validTypes.length === 0 || this.validTypes.includes(column.type);
    }

}
